import React from "react"
import AgentFormWrapper from "../../../AgentFormWrapper/AgentFormWrapper"
import DocLink from "../../../DocLink/DocLink"
import DebouncedValidatableInput from "../../../ValidatableInput/DebouncedValidatableInput"
import { nameof } from "../../../../utility/common/nameof"
import { AgentValues } from "../../../../models/agent"
import { FormikAgentFormProps } from "../../AgentForm"

const tNamespace = "agent:form."
const tLinkNamespace = "agent:link."

const FormikSurveysAgentFormGeneral: React.FC<FormikAgentFormProps> = props => {
    const { asyncState, agentType, t, handleSubmit, disabled, agent } = props

    return (
        <AgentFormWrapper
            agentType={agentType}
            onSubmit={handleSubmit}
            disabled={disabled}
            loading={asyncState.inProcess}
        >
            <DocLink type={agentType}>{t(`${tLinkNamespace}creating-agent-instructions`)}</DocLink>
            <div className="agent-form__section">
                <DebouncedValidatableInput
                    id="formTitle"
                    type="text"
                    name={nameof<AgentValues>("Id")}
                    label={t(`${tNamespace}title`)}
                    disabled={!!agent}
                />
            </div>
        </AgentFormWrapper>
    )
}

export default FormikSurveysAgentFormGeneral
